import { LoaderFunctionArgs } from "react-router-dom";
import { Api         } from "../api/Api";
import { Dataset } from "../api/Application";

export async function datasetListLoader( { params }: LoaderFunctionArgs ): Promise<Dataset[]> {
    const result = await Api.datasetList();
    if( result.isOk ) {
        return result.value;
    }
    throw new Error( "Couldn't load Dataset Images" );
}